export const COMPONENT_IMAGE_PLACEHOLDER =
  `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" fill="none">
      <rect width="96" height="96" rx="18" fill="#E8EFDA"/>
      <rect x="18" y="22" width="60" height="52" rx="10" fill="#F8FFE1" stroke="#DDE4CF" stroke-width="3"/>
      <circle cx="34" cy="38" r="6" fill="#D7FF37"/>
      <path d="M25 63L40 49L49 57L58 48L71 63" stroke="#6C8100" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `)}`;
